import script from "./WatchlistShare.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchlistShare.vue?vue&type=script&setup=true&lang=ts"

import "./WatchlistShare.vue?vue&type=style&index=0&id=525b95bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-525b95bc"]])

export default __exports__